import React, { Component } from "react";
import Layout from "../../hoc/layout/layout";
import "./faq.scss";
import BannerImg from "../../assets/images/faq/aka-07121802-17919@3x.png";
import FaqContent from "./faq.json";

class FaqPage extends Component {
  render() {
    return (
      <>
        {/* <div className="loader-box"></div> */}
        <div className="innerpage-sec faq-section">
          <div className="overlay">
            <img src={BannerImg} alt="" />
          </div>

          <div className="section-header">
            <div className="inner">
              <h1>FAQs</h1>
              <p>
                The information below answers frequently asked questions about the 70th Boule.
              </p>
              <ul>
                <li>
                  <a className="btn btn-green more-info" href="#virtual">
                    Virtual
                  </a>
                </li>
                <li>
                  <a className="btn btn-green more-info" href="#inperson">
                    In-Person
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div id="virtual" className="heading-box">
            <h2>Virtual</h2>
          </div>
          <div className="faq-box">
            <h5>What internet browser should I use?</h5>
            <p>
              For the best experience using VFairs, we recommend using the latest version of Chrome, Firefox, Safari or Edge. The VFairs app also runs on mobile web browsers. Other browsers may not have the latest web technologies necessary for online events to run in a web browser.
            </p>
            <p>
              For additional support regarding your browser, visit{""}
              <a href={`https://start.VFairs.com/en/check-browser/`} target="_blank">
                https://start.VFairs.com/en/check-browser
              </a>
              .
            </p>
          </div>

          <div className="faq-box">
            <h5>Can I customize my settings?</h5>
            <p>
              Visit and complete your profile on VFairs. You can include a short bio, customize your avatar/profile picture, add social media profiles and websites. This information will be shared if you choose to exchange information with a soror or vendor.
            </p>
          </div>

          <div className="faq-box">
            <h5>How do I know what is happening?</h5>
            <p>
              The Auditorium will display the schedule. Navigate the schedule by using filters to find plenary sessions, forums, and other special activities.
            </p>
          </div>

          <div className="faq-box">
            <h5>How do I attend an event?</h5>
            <p>
              All sessions, forums, activities will take place in the Auditorium in the Virtual Convention Center. You can access the convention center by clicking the links on the homepage or via the Agenda tab. Once in the Virtual Convention Center lobby, click the Auditorium to access all activities.
            </p>
          </div>

          <div className="faq-box">
            <h5>What is the suggested daily attire?</h5>
            <p>Monday, July 11 is Pink and Green.</p>
            <p>
              Tuesday, July 12 is Scarf Day. Scarves will be available for purchase in the AKA booth in the vendor area.
            </p>
            <p>Wednesday, July 13 is Green Day.</p>
            <p>Thursday, July 15 White Day. Uninterrupted White for Plenary Session 6. The attire for the Closing Gala is pink cocktail.</p>
          </div>

          <div className="faq-box">
            <h5>How do Delegates vote?</h5>
            <p>
              Virtual attendees are not able to serve as delegates.
            </p>
          </div>

          <div className="faq-box">
            <h5>What do I do if I want to speak from the floor</h5>
            <p>
              Virtual attendees will not be able to speak from the floor.
            </p>
          </div>

          <div className="faq-box">
            <h5>How do I engage with sorors?</h5>
            <p>
              There are several ways to engage sorors in the VFairs platform.
            </p>
            <p>
              Within the Virtual Convention Center, access the Lounge to enter chat rooms and engage with other sorors.
            </p>
            <p>
              Take a photo in the virtual Photo Booth. Add frames, stickers, filters to showcase your Boule spirit. Share the photo within the conference and on your social media.
            </p>
            <p>
              From the VFairs app, post to our internal 70th Boule social media platform.
            </p>
          </div>

          <div className="faq-box">
            <h5>How do I shop for vendors?</h5>
            <p>
              Virtual attendees can access vendors in the 70th Boule Virtual Convention Center on the VFairs platform.
            </p>
          </div>

          <div className="faq-box">
            <h5>I am looking for a specific vendor and don’t see them?</h5>
            <p>
              Each exhibit hall will have a listing of vendors located in that hall. A complete directory is included in the Agenda Book and on the platform.
            </p>
            <p>
              There is a search bar on the Exhibitor Hall lobby page above the navigation bar which will take you directly to a specific vendor’s booth. Please note that all AKA-licensed vendors do not have booths for this combined conference.            </p>
            <p>
              Not all vendors opted into the virtual exhibit hall.
            </p>
          </div>

          <div className="faq-box">
            <h5>
              Can I purchase items in the Exhibit Hall through the platform?
            </h5>
            <p>
              All vendors will link to their online store, and attendees can make purchases from their website. Please check with the vendor to see preferred payment methods.
            </p>
          </div>

          <div className="faq-box">
            <h5>
              Will the sessions be recorded or archived for future access?
            </h5>
            <p>
              Plenary sessions will not be recorded. Other activities that are streamed will be recorded for archival purposes. These activities include:

              <ul>
                <li><p>Diamond, Pearl, Golden, and Silver Luncheon</p></li>
                <li><p>Social Justice Forum</p></li>
                <li><p>Voting Rights Forum</p></li>
                <li><p>Closing Gala/Office Installation</p></li>
              </ul>
            </p>

            <p>
              If you miss one of these activities, you will be able to view the recording when made available later.
            </p>
          </div>


          <div className="faq-box">
            <h5>Who do I contact for assistance?</h5>
            <p>
              For assistance with your Membership Profile, contact
              <a href="mailto:members@aka1908.com">members@aka1908.com</a>.
            </p>
            <p>
              For assistance accessing the virtual Convention Center or general Boule help, click on the Help Desk/Soror Services.
            </p>
            <p>
              For assistance with the virtual Convention Center, select Info Desk from the navigation bar or lobby.
            </p>
            <p>
              The help desks are staffed during conference hours.
            </p>
          </div>


          <div id="inperson" className="heading-box">
            <h2>In-Person</h2>
          </div>


          <div className="faq-box">
            <h5>Where will the Boule events be held?</h5>
            <p>
              Most activities will be held at the Orange County Convention Center, including registration, all plenary sessions, forums, voting, and the closing gala. However, there are select activities that are held at other locations. Please see the agenda for locations.
            </p>
          </div>

          <div className="faq-box">
            <h5>What are the on-site COVID-19 Health Protocols?</h5>
            <p>
              <ul>
                <li><p>Sorors attending the Boule in person must provide proof of a
                  negative COVID test within 72 hours of arrival for Boule registration
                  check-in. The COVID test may be PCR, Antigen, or
                  a home test. The results must be uploaded to the Boule Health
                  Pass portal prior to registration. For information on uploading
                  your information, click
                  <a href={`https://s3-us-west-2.amazonaws.com/aka-events/files/Boule-2022/Health_Pass_Instructions.pdf`} target="_blank">
                    here
                  </a>
                </p></li>
                <li><p>Sorors attending the Boule in person should wear a mask at all times.</p></li>
                <li><p>Sorors attending the Boule in person must adhere to social distancing requirements to the extent possible and sanitization procedures.</p></li>
                <li><p>Sorors must stay home if either the soror or a member of the soror’s household has tested positive for COVID, is in isolation, or is quarantined.</p></li>
              </ul>
            </p>
          </div>


          <div className="faq-box">
            <h5>What is the attire for the conference?</h5>
            <p>
              As the Boule is a business meeting, the plenary session attire is sorority business. The special attire days are as follows:
              <ul>
                <li><p>Monday: Pink and Green Day</p></li>
                <li><p>Tuesday: Scarf Day</p></li>
                <li><p>Wednesday: Green Day</p></li>
                <li><p>Thursday: White Day</p></li>
              </ul>
            </p>
            <br />
            <p>
              Other attire requirements are as follows:
              <ul>
                <li><p>Rededication – No Pants Permitted</p></li>
                <li><p>Ivies Beyond the Wall Ceremony – Uninterrupted White Only and Stockings or Panty Hose</p></li>
                <li><p>Closing Gala – Pink Cocktail or Pink Formal</p></li>
              </ul>
            </p>
          </div>


          <div className="faq-box">
            <h5>Are there any workshops?</h5>
            <p>
              There will be no workshops held at the 70th Boule.
            </p>
          </div>

          <div className="faq-box">
            <h5>How do registrants get to the convention center?</h5>
            <p>
              Transportation is available from all official Boule hotels, except for the walking hotels near the convention center. The bus schedule for the hotels may be found
              <a href={`https://s3-us-west-2.amazonaws.com/aka-events/files/Boule-2022/Bus_Schedule.pdf`} target="_blank">
                here
              </a>
            </p>
          </div>

          <div className="faq-box">
            <h5>Is there a mobile app for the conference?</h5>
            <p>
              Because the 70th Boule is a hybrid event, AKA will leverage the technology of our virtual platform’s mobile app, even for in-person guests. Download the vFairs app and…
            </p>
          </div>


          <div className="faq-box">
            <h5>Can I add activities to my registration?</h5>
            <p>
              Activities cannot be added to registrations at this time. All meal functions require previous registration. All other activities are open to all registrants.
            </p>
          </div>

          <div className="faq-box">
            <h5>Do in-person registrants have access to the sessions online?</h5>
            <p>
              Yes, in-person registrants have access to view the virtual activities, including the plenary sessions, forums, the DPGS luncheon, and the closing gala.
            </p>
          </div>


          <div className="faq-box">
            <h5>Are guests allowed to attend the closing gala?</h5>
            <p>
              Registered guests are allowed to attend the closing gala. Registered youth and children or unregistered persons are not allowed to attend the closing gala.
            </p>
          </div>

          <div className="faq-box">
            <h5>Can delegates or alternates be added to the delegate list?</h5>
            <p>
              The deadline to add chapter delegates and alternates to the chapters roster of delegates was June 10, 2022. At this time, no alternates and delegates can be added. However, delegates can be removed, and alternates can be promoted to delegates in the Delegate Certification area in Hall C.
            </p>
          </div>

          <div className="faq-box">
            <h5>Can delegates vote remotely?</h5>
            <p>
              Delegates cannot vote remotely within the plenary session or in elections. Delegates must be registered as in-person attendees, certified by Monday at noon, and present to vote on Tuesday between 7 am and 3 pm.
            </p>
          </div>

        </div>
      </>
    );
  }
}

export default FaqPage;
